/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import classNames from 'classnames/bind';
import { Typography } from 'gd-design-library';
import { PDPSpecifications } from '@services';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import styles from '../ProductStaticContent.module.scss';

const CN = 'product-static-content';
const productDetailsItemClassName = `${CN}__product-details-item`;
const productDetailsItemTitleClassName = `${productDetailsItemClassName}__title`;
const specificationsTableClassName = `${CN}__specs-table`;
const cx = classNames.bind(styles);

interface Props {
  specifications: PDPSpecifications;
}

export const Specifications: React.FC<Props> = ({
  specifications: {
    title,
    table_rows
  }
}) => (
  <div className={ cx(productDetailsItemClassName) }>
    <Typography className={ cx(productDetailsItemTitleClassName) } variant='h4' >
      {title}
    </Typography>
    <Table className={ cx(specificationsTableClassName) }>
      <TableBody>
        {table_rows.map(row => (
          <TableRow key={ row.value }>
            <TableCell>
              <Typography>
                {row.attribute_name}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography>
                {row.value}
              </Typography>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);
